import { Tooltip as AntdTooltip } from "antd";

import type { TooltipProps } from "./types";

/**
 * Tooltip is a small pop-up box that appears when the user moves the mouse pointer over an element.
 * Can be used to provide helpful information to the user.
 * Is shown on mouse enter, and is hidden on mouse leave.
 * Doesn't support complex text or operations.
 */
function Tooltip(props: TooltipProps) {
  return <AntdTooltip {...props} />;
}

export { Tooltip };
